import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, Clock, RefreshCw, Check, PauseCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/services/api';

// Homepage "Apply as Organizer" call-to-action (Organizer V1 — Phase 1). Renders only
// for logged-in users, with state driven by GET /api/users/me/organizer-application
// (404 => no application yet). Mirrors DJCallToAction. Approved organizers are pointed
// to their status page (the dedicated /organizer/dashboard arrives in a later phase).
const STATES = {
  none:            { icon: Building2,   title: 'Are you an event organizer?', sub: 'Apply to get a verified public organizer profile.', cta: 'Apply as Organizer',        to: '/organizer-apply' },
  pending:         { icon: Clock,       title: 'Organizer Application Submitted', sub: 'Your application is under review.',              cta: 'View Application Status',   to: '/organizer-status' },
  request_changes: { icon: RefreshCw,   title: 'Changes Requested',           sub: 'The reviewer asked for updates to your application.', cta: 'Update & Resubmit',        to: '/organizer-status' },
  rejected:        { icon: RefreshCw,   title: 'Organizer Application',       sub: 'Your application was not approved.',              cta: 'View Status',               to: '/organizer-status' },
  approved:        { icon: Check,       title: 'You are a SoundWolves Organizer', sub: 'Your organizer profile is approved.',         cta: 'View Organizer Status',     to: '/organizer-status' },
  suspended:       { icon: PauseCircle, title: 'Organizer Profile',           sub: 'Your organizer profile is currently suspended.',  cta: 'View Status',               to: '/organizer-status' },
};

export function OrganizerCallToAction() {
  const [state, setState] = useState(null);   // application status key or 'none'
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!api.isAuthenticated()) { setReady(true); return; }
    api.get('/users/me/organizer-application')
      .then((app) => setState(app?.status || 'none'))
      .catch(() => setState('none'))   // 404 => no application
      .finally(() => setReady(true));
  }, []);

  if (!ready || !api.isAuthenticated() || !state) return null;
  const cfg = STATES[state] || STATES.none;
  const Icon = cfg.icon;

  return (
    <section className="py-6 border-b border-border/50" data-testid="organizer-cta">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/20"><Icon className="w-5 h-5 text-primary" /></div>
            <div>
              <p className="font-display font-bold">{cfg.title}</p>
              <p className="text-sm text-muted-foreground">{cfg.sub}</p>
            </div>
          </div>
          <Link to={cfg.to}><Button variant="premium" size="sm">{cfg.cta}</Button></Link>
        </div>
      </div>
    </section>
  );
}

export default OrganizerCallToAction;
